export default __webpack_public_path__ + "static/media/second_section_left.c159fd56.png";